import { ButtonGroup } from '@material-ui/core';
import cx from 'classnames';
import MuiButton from 'components/common/button/MuiButton';
import TeethContextMenu from 'components/common/teeth/clinic/TeethContextMenu';
import TeethSvgV2 from 'components/common/teeth/clinic/TeethSvgV2';
import TeethSvgV2Photogrammetry from 'components/common/teeth/clinic/TeethSvgV2Photogrammetry';
import { T } from 'components/common/text';
import { ITooth, IToothCopyData } from 'lib/types/clinic/projectTypes';
import React, { useEffect, useMemo, useRef } from 'react';
import { StoreSetter } from 'store/local/utils';
import styled from 'styled-components';

interface ProjectTeethPhotogrammetryProps {
  isViewer?: boolean;
  numbering?: number;
  setNumbering?: StoreSetter<number>;
  tooth?: ITooth | null;
  setTooth?: StoreSetter<ITooth | null>;
  onNumberingClick?: (numbering: number) => void;
  teeth?: ITooth[];
  setTeeth?: StoreSetter<ITooth[]>;
  bridge?: number[];
  setBridge?: StoreSetter<number[]>;
  copyData?: IToothCopyData;
  setCopyData?: StoreSetter<IToothCopyData>;
  teethContextActions?: {
    value: any;
    setValue: (f: (draft: any) => any) => void;
  };
  onToggleTooth?: (toothNumber: number) => void;
  onChangeToothValue?: (data: object | any) => void;
  onCopyTeeth?: (copyDataList: ITooth[]) => void;
}

const ProjectTeethPhotogrammetry = ({
  isViewer = false,
  numbering,
  setNumbering,
  tooth,
  setTooth,
  teeth,
  setTeeth,
  bridge,
  setBridge,
  copyData,
  setCopyData,
  teethContextActions,
  onToggleTooth,
  onChangeToothValue,
  onNumberingClick,
  onCopyTeeth,
}: ProjectTeethPhotogrammetryProps) => {
  const toothSvgRef = useRef(null);

  return (
    <StyledProjectTeeth>
      {!isViewer && <div className="projectTeethPhotogrammetry__numbering_tab_box"></div>}
      <div className="projectTeethPhotogrammetry__teeth_box">
        {useMemo(() => {
          return (
            <div className={cx('projectTeethPhotogrammetry__teeth_item')}>
              <input className="projectTeethPhotogrammetry__teeth_focus_point" ref={toothSvgRef} />
              {isViewer ? (
                <TeethSvgV2Photogrammetry
                  isEdit={false}
                  tooth={tooth}
                  teeth={{ value: teeth }}
                  numbering={{ value: numbering }}
                  // tooth={{ value: tooth, setValue: setTooth }}
                  // teeth={{ value: teeth, setValue: setTeeth }}
                  bridge={{ value: bridge }}
                  onToggleTooth={(toothNumber: number) => {
                    onToggleTooth && onToggleTooth(toothNumber);
                  }}
                />
              ) : (
                <TeethSvgV2Photogrammetry
                  isEdit={true}
                  numbering={{ value: numbering, setValue: setNumbering }}
                  teeth={{ value: teeth, setValue: setTeeth }}
                  tooth={{ value: tooth, setValue: setTooth }}
                  bridge={{ value: bridge, setValue: setBridge }}
                  copyData={{ value: copyData, setValue: setCopyData }}
                  teethContextActions={teethContextActions}
                  onToggleTooth={(toothNumber: number) => {
                    onToggleTooth && onToggleTooth(toothNumber);
                  }}
                  onChangeToothValue={onChangeToothValue}
                />
              )}
            </div>
          );
        }, [numbering, teeth, tooth, bridge, copyData, teethContextActions])}
      </div>
    </StyledProjectTeeth>
  );
};

const StyledProjectTeeth = styled.div`
  height: 100%;
  width: 100%;
  .projectTeethPhotogrammetry__numbering_tab_box {
    position: relative;
    width: 100%;
    margin-bottom: 38px;
    height: 32px;
    .projectTeethPhotogrammetry__numbering_tab {
      min-width: 50%;
    }
  }
  .projectTeethPhotogrammetry__teeth_box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    .projectTeethPhotogrammetry__teeth_item {
      max-width: 353px;
      width: 100%;
      .projectTeethPhotogrammetry__teeth_focus_point {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        display: block;
        margin: 0;
        padding: 0;
        border: none;
      }
    }
  }
`;

export default ProjectTeethPhotogrammetry;
